import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { translationPropType } from '@eb/i18n-ebspa';
import { Button } from '@eb/eds-button';
import { TYPE_LINK, SIZE_BLOCK } from '@eb/eds-button';

import { gettext } from '@eb/i18n-ebspa';
import { SEE_MORE_PROPTYPE } from '../constants/propTypes';

export default class SeeMore extends PureComponent {
    static propTypes = {
        onClick: PropTypes.func.isRequired,

        bucketKey: PropTypes.string,
        label: translationPropType,
        seeMore: SEE_MORE_PROPTYPE,
        title: translationPropType,
    };

    render() {
        const { bucketKey, label, onClick, seeMore, title } = this.props;
        const buttonLabel = label ? label : gettext('See more');
        const ariaLabel = title
            ? gettext('See more %(title)s', { title })
            : gettext('See even more events');

        let component = null;

        if (onClick && seeMore && seeMore.url) {
            component = (
                <div className="eds-align--center eds-l-mar-top-2">
                    <div className="eds-g-cell eds-g-cell-6-12 eds-g-cell-sw-4-12">
                        <Button
                            type={TYPE_LINK}
                            href={seeMore.url}
                            onClick={onClick.bind(null, seeMore.url, bucketKey)}
                            aria-label={ariaLabel}
                            size={SIZE_BLOCK}
                        >
                            {buttonLabel}
                        </Button>
                    </div>
                </div>
            );
        }

        return component;
    }
}
